/** @module SiteAdmin/Lookup/SpecificationItemMixin */
define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/xml"
], function(declare,reflection,xml) {

	return declare(null, {
		LOOKUP_ITEM_SUBTYPE:"LookupItemSubtype",
		VALIDATION_EXPRESSION:"ValidationExpression",
		VALIDATION_ERROR_MESSAGE:"ValidationErrorMessage",

		/*
		 * @override
		 * Add value attr params to the call
		 */
		toWriter: function() {
			var fd = this.m_formData;
			var type = fd.getFieldValue(reflection.ATTR_VALUETYPE, true);
			var format = fd.getFieldValue(reflection.ATTR_FORMAT, true);
			var lookupItemSubtype = fd.getFieldValue(this.LOOKUP_ITEM_SUBTYPE, true);
			var valExpr = fd.getFieldValue(this.VALIDATION_EXPRESSION, true);
			var valErrorMsg = fd.getFieldValue(this.VALIDATION_ERROR_MESSAGE, true);

			var	call = this.inherited(arguments);
			if (call) {
				call.addParameter(reflection.ATTR_SUBTYPE, xml.ATTR_REF, fd.getFieldValue(reflection.ATTR_SUBTYPE))
				call.addParameter(reflection.ATTR_VALUETYPE, xml.ATTR_STRING, type);
				call.addParameter(reflection.ATTR_FORMAT, xml.ATTR_STRING, format);
				call.addParameter(this.LOOKUP_ITEM_SUBTYPE, xml.ATTR_REF, lookupItemSubtype);
				call.addParameter(this.VALIDATION_EXPRESSION, xml.ATTR_STRING, valExpr);
				call.addParameter(this.VALIDATION_ERROR_MESSAGE, xml.ATTR_STRING, valErrorMsg);
			}

			return call;
		}
	});
});